import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
// import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { InputMaskModule } from '@ngneat/input-mask';
import { SeatsioAngularModule } from '@seatsio/seatsio-angular';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { ToastrModule } from 'ngx-toastr';
import { SwiperModule } from 'swiper/angular';
import { FunctionZoneInventoryComponent } from './components/function-zone-inventory/function-zone-inventory.component';
import { GoliiiveSeatsIoSeatingChartComponent } from './components/goliiive-seats-io-seating-chart/goliiive-seats-io-seating-chart.component';
import { ImageEditorOverlayComponent } from './components/image-editor-overlay/image-editor-overlay.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { IndeterminateLoaderComponent } from './components/indeterminate-loader/indeterminate-loader.component';
import { InputFieldMakerComponent } from './components/input-field-maker/input-field-maker.component';
import { ModalActionComponent } from './components/modal-action/modal-action.component';
import { ModalActionService } from './components/modal-action/modal-action.service';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PaymentBanamexComponent } from './components/payment-banamex/payment-banamex.component';
import { SwiperComponent } from './components/swiper/swiper.component';
import { TabsStepperComponent } from './components/tabs-stepper/tabs-stepper.component';
import { TemplateExampleComponent } from './components/template-example/template-example.component';
import { ModalOverlayDirective } from './directives/modal-overlay.directive';
import { LazyImageDirective } from './directives/r3zu3/lazy-image.directive';
import { ParallaxEffectDirective } from './directives/r3zu3/parallax-effect.directive';
import { ValidateAccessDirective } from './directives/validate-access.directive';
import { AuthService } from './services/auth/auth.service';
import { ExperiencesService } from './services/experiences/experiences.service';
import { GlobalValidateAccessDirective } from './directives/global-validate-access.directive';
import { JspmPrintTicketComponent } from './components/jspm-print-ticket/jspm-print-ticket.component';
import { ValidateAccessExperienceDirective } from './directives/validate-access-experience.directive';
import { GlobalValidateAccessExperienceDirective } from './directives/global-validate-access-experience.directive';
import { FilterReportComponent } from './components/filter-report/filter-report.component';
import { InputCkeditorComponent } from './components/input-ckeditor/input-ckeditor.component';

const MODULES = [
  CdkAccordionModule,
  CdkStepperModule,
  DragDropModule,
  OverlayModule,
  ScrollingModule,
  NgxTippyModule,
  FormsModule,
  SwiperModule,
  CommonModule,
  ImageCropperModule,
  NgSelectModule,
  ReactiveFormsModule,
  GoogleMapsModule,
  CKEditorModule,
  SeatsioAngularModule,
  NgxDropzoneModule,
];

const STANDALONE_MODULES = [
  NgxMaskModule.forRoot(),
  ToastrModule.forRoot(),
  InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true }),
];


const COMPONENTS = [
  SwiperComponent,
  ImageEditorOverlayComponent,
  TabsStepperComponent,
  GoliiiveSeatsIoSeatingChartComponent,
  FunctionZoneInventoryComponent,
  InputFieldMakerComponent,
  IndeterminateLoaderComponent,
  PaginationComponent,
  ImageUploaderComponent,
  ModalActionComponent,
  TemplateExampleComponent,
  PaymentBanamexComponent,
  JspmPrintTicketComponent,
  FilterReportComponent,
  InputCkeditorComponent
];

const DIRECTIVES = [
  ParallaxEffectDirective,
  ModalOverlayDirective,
  LazyImageDirective,
  ValidateAccessDirective,
  GlobalValidateAccessDirective,
  ValidateAccessExperienceDirective,
  GlobalValidateAccessExperienceDirective
];

const PIPES = [[]];

const PROVIDERS = [
  AuthService,
  // VenuesService,
  ExperiencesService,
  ModalActionService,
  DecimalPipe,
];

@NgModule({
  declarations: [...DIRECTIVES, ...COMPONENTS, ...PIPES],
  imports: [...MODULES, ...STANDALONE_MODULES],
  providers: [...PROVIDERS, ...PIPES],
  exports: [...MODULES, ...DIRECTIVES, ...COMPONENTS, ...PIPES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  static forRoot() {
    return {
      ngModule: SharedModule,
      declarations: [...DIRECTIVES, ...COMPONENTS, ...PIPES],
      imports: [...MODULES, ...STANDALONE_MODULES],
      providers: [...PROVIDERS, ...PIPES],
      exports: [...MODULES, ...DIRECTIVES, ...COMPONENTS, ...PIPES],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    };
  }
}
